/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

import { hash } from '@linc-technologies/linced-common/utils/promise';
import moment from 'moment';

export default class FundingYearLevelRoute extends Route {
  queryParams = {
    date: {
      refreshModel: true,
    },
  };

  // Services
  @service
  store;

  // State
  year = moment().format('YYYY');

  model(params) {
    return hash({
      enrolments: this.store.query('people/enrolment', {
        asAtDate: params.date,
        include: 'people',
      }),
    });
  }
}
